import {
    IMAGE_SERVER_URL,
    IMAGE_SERVER_URL_DEV,
    IMAGE_SERVER_URL_DEV2,
} from "../../Constant/System";
import _ from "lodash";
var moment = require("moment");

function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {

        var result =
            a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
    };
}
function groupByKey(array, key) {
    return array.reduce((hash, obj) => {
        if (obj[key] === undefined) return hash;
        return Object.assign(hash, {
            [obj[key]]: (hash[obj[key]] || []).concat(obj),
        });
    }, {});
}

export const EMAIL_TAMPLETE2 = ({
    customerName,
    address,
    invoiceNo,
    date,
    tax,
    MESSAGE,
    address2,
    address3,
    address4,
    iUsers = [],
    currency,
    amount,
    delivery,
    logo
}) => {

    return `
      <html lang='en'>
    
      <head>
          <meta charset='utf-8' />
          <title>Quotation - Spotly</title>
          <meta name='viewport' content='initial-scale=1.0; maximum-scale=1.0; width=device-width;'>
     
          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link
              href="https://fonts.googleapis.com/css2?family=Asap+Condensed:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap"
              rel="stylesheet">
          <style>
              @import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700,300,100);
      
          
              .txt-primary {
                  color:#2d867b
              }
      
              .background-primary {
                  background-color:#2d867b
              }
      
              .background-secondary {
                  background-color: #E5DDD8
              }
      
              .background-tertiary {
                  background-color: #2d867b
              }
      
              .txt-secondary {
                  color: #2d867b
              }
      
              .invoice-container {
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
              }
      
              .invoice-details-container {
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-end;
                  flex-direction: column;
              }
      
              .txt-invoice {
                  font-family: 'Inter', sans-serif;
                  text-transform: uppercase;
                  text-align: right;
                  font-weight: bold;
                  letter-spacing: 2;
              }
      
              .txt-1 {
                  font-size: 7pt;
                  font-weight: 700;
                  letter-spacing: 0.8px;
                  font-family: 'Inter', sans-serif;
              }
      
              .txt-2 {
                  font-size: 15pt;
                  font-weight: 600;
                  font-family: 'Inter', sans-serif;
              }
      
              .txt-3 {
                  font-size: 7pt;
                  font-weight: 400;
                  font-family: 'Inter', sans-serif;
              }
      
              .tb-row-1 {
      
                  padding: 5px 0px;
                  font-size: 7pt;
                  font-weight: 400;
                  /* display: flex; */
                  /* align-items: center; */
                  font-family: 'Inter', sans-serif;
                  /* letter-spacing: 0.8; */
      
              }
      
              .tb-row-2 {
      
                  padding: 6px 0px;
                  font-size: 7pt;
                  font-weight: 400;
                  /* display: flex;
                  align-items: center; */
                  font-family: 'Inter', sans-serif;
                  letter-spacing: 0.8;
      
              }
      
              .txt-4 {
                  padding: 6px 5px;
                  font-size: 14pt;
                  font-weight: 400;
                  display: flex;
                  align-items: center;
                  font-family: 'Inter', sans-serif;
                  letter-spacing: 1;
              }
      
              .contact-container {
                  display: flex;
                  justify-content: center;
                  flex-direction: column;
                  align-items: center;
      
              }
      
              .txt-5 {
                  font-size: 11pt;
                  font-weight: 600;
      
                  font-family: 'Inter', sans-serif;
                  letter-spacing: 2px;
              }
      
              .txt-6 {
                  font-family: 'Inter', sans-serif;
                  letter-spacing: 0.8px;
                  font-size: 10pt;
                  margin-bottom: 3px;
              }
      
              .txt-7 {
                  font-family: 'Inter', sans-serif;
                  font-weight: 400;
                  letter-spacing: 0.8px;
                  font-size: 9pt;
              }
      
              .custom-hr {
                  width: 30%;
                  height: 1.5px;
                  margin: 6px 0px 10px;
                  opacity: 1;
              }
      
              th {
                  /* height: 32px;
                  padding: 10px; */
                  height: 25px;
                  padding: 5px;
                  text-align: left;
              }
      
              td {
                  height: 20px;
                  padding: 5px 10px;
                  text-align: left;
      
              }
      
              body {
                  background-color: #fff;
                  padding: 0;
                  margin: 0;
              }
          </style>
      </head>
      
      <body>
      <div class="container" style="background:#fff;">
      <div style="padding: 5%;min-height:590px;">
          <table style="width:100%">
              <tr>
                  <td>
                      <img src="${IMAGE_SERVER_URL_DEV}/uploads/logo/tidytraderr.png"
                          style="width:45%;min-width:45%;object-fit:contain" alt="logo" />
                  </td>
                  <td>
                      <h3 class="txt-primary txt-invoice" style="font-size:11pt;margin-bottom: 0px;white-space: nowrap;">
                      ITEM SUMMARY
                      </h3>
                  </td>
              </tr>
          </table>
          <table style="width:100%">
              <tr>
                  <td>
                      <div style="margin-bottom:2px;" class="txt-secondary txt-1">
                      QUOTATION TO:
                      </div>
                      <div style="margin-bottom:2px;white-space: nowrap;color:#222" class="txt-secondary txt-3">
                      ${customerName}
                      </div>
                      <div class="txt-secondary txt-3" style="max-width:85%;color:#222">
                      ${address}
                      <br/>
                      ${address2}
                      <br/>
                      ${address3}
                      <br/>
                      ${address4}
                      </div>
                  </td>
                  <td style="text-align: right;display:block;">
                      <div style="margin-bottom:2px;white-space: nowrap;margin-top:-40px" class="txt-secondary txt-1">
                      QUOTATION DETAILS
                      </div>
                      <div style="margin-bottom:2px;color:#222" class="txt-secondary txt-3">
                      No. ${invoiceNo}
                      </div>
                      <div style="color:#222" class="txt-secondary txt-3">
                      ${moment(new Date(date)).format("DD/MM/YYYY")}
                      </div>
                  </td>
              </tr>
          </table>
  
          <div style="padding: 15px 0px 5px; ">
              <table style="width:100%;border-spacing: 0;">
  
                  <tr class=" background-primary" style="color: white;
                    
                      font-size: 7pt;
                      font-weight: 500;">
                      <th style="width:40%;">Product</th>
                      <th style="text-align:left;width:40%;">Seller</th>
                      <th style="text-align:center;">Qty</th>
                      <th>Price</th>
                      <th>Subtotal</th>
                  </tr>
                  ${iUsers?.map((item, index) => {

        let unitPrice = 0;
        let discount = item.discount;
        let cartQty = item.qty >= 1 ? item.qty : 1;

        //   const newArr = JSON.parse(item.priceDetails)?.map(single => {

        //     if (cartQty === single.qty)
        //       unitPrice = single.unitPrice
        //   })

        unitPrice = item.unitprice;


        // const discountedPrice = cartItem.discountedprice;
        // const finalProductPrice = cartItem.unitprice?.toFixed(2);
        // const finalDiscountedPrice = cartItem.discountedprice?.toFixed(2);
        const finalProductPrice = parseFloat(unitPrice)
        const discountedPrice = parseFloat(unitPrice * discount / 100)
        const finalDiscountedPrice = parseFloat(unitPrice * cartQty).toFixed(2)
        return `
                    <tr class="txt-secondary tb-row-1 ">
                    
                    <td>${item?.productName}<br />
                    ${item?.selectedProductSize ? `Size: ${item?.selectedProductSize}<br/>` : ""}
                    ${item?.selectedProductColor ? `Color: ${item?.selectedProductColor}` : ""}
                    </td>
                    <td style="text-align:left;">${item?.supplierName}</td>

                    <td style="text-align:center;">${item?.qty}</td>
                    <td>${currency} ${parseFloat(item.unitPrice).toFixed(2)}</td>
                    <td>${currency} ${finalDiscountedPrice}</td>
                </tr>
                    `;
    })}
                
                  <tr>
                      <td colspan="5" style="height:0;padding-top:0;padding:3px;border-top:2px solid #2d867b ;">
                      </td>
                  </tr>
                  <tr class="txt-secondary tb-row-1">
                      <td style="height:18px;padding:0px 10px" style="text-align:center;" colspan="3"></td>
  
                      <td style="height:18px;padding:2px 10px 0px 10px;text-align: left;">Subtotal</td>
                      <td style="height:18px;padding:5px 10px;text-align: right;">${currency} ${parseFloat(amount).toFixed(2)}</td>
                  </tr>

                  <tr class="txt-secondary tb-row-1">
                  <td style="height:18px;padding:0px 10px" style="text-align:center;" colspan="3"></td>

                  <td style="height:18px;padding:2px 10px 0px 10px;text-align: left;">Delivery</td>
                  <td style="height:18px;padding:5px 10px;text-align: right;">${currency} ${parseFloat(delivery).toFixed(2)}</td>
              </tr>

                  <tr class="txt-secondary txt-1">
                      <td style="height:18px;padding:0px 10px" style="text-align:center;" colspan="3"></td>
  
                      <td style="height:18px;padding:2px 10px 0px 10px;text-align: left;">Total</td>
                      <td style="height:18px;padding:5px 10px;text-align: right;">${currency} ${parseFloat(amount + parseFloat(delivery)).toFixed(2)}</td>
                  </tr>
              </table>
          </div>
      </div>
      
              <div style="padding: 30px 25px 10px;font-family: 'Inter', sans-serif;          
              text-align: center;
              font-size: 13pt;">
                  
                 
       
        <div class="contact-container " style="display: block; text-align:center ;margin-bottom: 40px;margin-top:20px">
        <h3 style="margin-bottom: 5px;display: block; " class="txt-primary txt-5">
            CONTACT SUPPORT
        </h3>
        <hr class="background-tertiary custom-hr" style="display: inline-block;" />
        <h4 style="margin-top: 0px;" class=" txt-secondary txt-6">
       
        </h4>
        <h5 style="margin:5px" class="txt-secondary txt-7">
        support@infinitycs.com.au
        </h5>
    </div>
        </div>
        </div>
          </div>
          </div>
            </div>
        </body>
        
        </html>`;
};
